export const REQUEST_LAST_LOGIN_DETAILS = 'REQUEST_LAST_LOGIN_DETAILS';
export const REQUEST_LAST_LOGIN_DETAILS_SUCCESS =
  'REQUEST_LAST_LOGIN_DETAILS_SUCCESS';
export const REQUEST_LAST_LOGIN_DETAILS_ERROR =
  'REQUEST_LAST_LOGIN_DETAILS_ERROR';

export const INIT_LAST_LOGIN_ALERT = 'INIT_LAST_LOGIN_ALERT';
export const INIT_LAST_LOGIN_ALERT_SUCCESS = 'INIT_LAST_LOGIN_ALERT_SUCCESS';
export const INIT_LAST_LOGIN_ALERT_ERROR = 'INIT_LAST_LOGIN_ALERT_ERROR';

export const DISMISS_LAST_LOGIN_ALERT = 'DISMISS_LAST_LOGIN_ALERT';

export const PLATFORM_ANDROID = 'ANDROID';
export const PLATFORM_IOS = 'IOS';
export const PLATFORM_WEB = 'WEB';

export const ICON_DICT_LARGE = {
  [PLATFORM_ANDROID]: 'MobileOutlineLarge',
  [PLATFORM_IOS]: 'MobileOutlineLarge',
  [PLATFORM_WEB]: 'Desktop',
};

export const ICON_DICT_SMALL = {
  [PLATFORM_ANDROID]: 'MobileOutlineSmall',
  [PLATFORM_IOS]: 'MobileOutlineSmall',
  [PLATFORM_WEB]: 'Desktop',
};
